var _g, _defs;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgKitchenUtensils = function SvgKitchenUtensils(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2802_31504)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.666 0V20",
    strokeWidth: 2.625
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 14.666,
    cy: 25.3333,
    rx: 4,
    ry: 5.33333,
    strokeWidth: 2.625
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.6673 7.04754C30.6673 11.4658 28.578 17.3333 26.0007 17.3333C23.4233 17.3333 21.334 11.4658 21.334 7.04754C21.334 2.62926 23.4233 1.33325 26.0007 1.33325C28.578 1.33325 30.6673 2.62926 30.6673 7.04754Z",
    strokeWidth: 2.625
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.33203 33.3334V17.3334M1.33203 17.3334V2.66675C1.33203 2.66675 6.66536 4.66675 6.66536 14.6667C6.66536 16.0001 6.66536 17.3334 6.66536 17.3334H1.33203Z",
    strokeWidth: 2.625
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.998 1.33325V31.9999",
    strokeWidth: 2.625
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2802_31504"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgKitchenUtensils, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Kitchen Utensils.058c4500.svg";
export { ForwardRef as ReactComponent };